// extracted by mini-css-extract-plugin
module.exports = {"dark":"#000","light":"#fff","color1":"#5cb85c"};